
import Component from 'vue-class-component';
import { Emit, Prop, Watch } from 'vue-property-decorator';
import { BaseComponent } from '@/decorators';
import Quill from 'quill';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
@Component
export default class IQuill extends BaseComponent {
    name="i-quill";
    content:string = '';
    quill:any = {
        newQuill:null,
    }

    options = {
        theme: "snow",
        bounds: document.body,
        debug: "warn",
        modules: {
            toolbar:false,
        },
        placeholder: "请输入拟办意见...",
        readOnly: false,
    }

    @Prop({default:100})
    height!:number;

    @Prop({default:100})
    minHeight!:number;

    @Prop({default:true})
    border!:boolean;

    @Prop({ default: null })
    value!: string;

    @Watch("value", { immediate: true })
    public async watchValue() {
        if (this.value && this.value!==this.content){
            this.content = this.value;
            const editor = this.getQuill();
            if (editor.newQuill) {
                editor.newQuill.pasteHTML(this.value);
            }
        }
    }

    
    public get classes () {
        return [
            {
                'i-quill-no-border': !this.border
            }
        ];
    };

    public get styles() {
        let style = {
            minHeight: "",
            height: "",
        }
        if (this.minHeight) {
            style.minHeight = `${this.minHeight}px`
        }
        if (this.height) {
            style.height = `${this.height}px`
        }
        return style
    }
    
    beforeUnmount() {
        const editor = this.getQuill()
        // 在组件销毁后销毁实例
        if (editor.newQuill) {
            editor.newQuill = null
        }
    }

    mounted(){
       this.init();
    }

    @Emit('input')
    TextChanged(v: any) {
        return v;
    }

    getQuill() {
        return this.quill;
    }


    clear(){
        this.content = '';
         this.quill.newQuill .pasteHTML(this.content)
    }

    init() {
        const editor = this.$refs.editor as HTMLElement;
        if(!this.quill.newQuill){
             // 初始化编辑器
            this.quill.newQuill = new Quill(editor, this.options);
        }
       
        // 默认值
        this.quill.newQuill .pasteHTML(this.content)
        // 绑定事件
        this.quill.newQuill .on("text-change", (delta:any, oldDelta:any, source:any) => {
            const html = editor.children[0].innerHTML
            const text = this.quill.newQuill .getText()
            // 更新内部的值
            this.content = html
            // 发出事件 v-model
            // this.$emit("update:modelValue", html)
            this.TextChanged(html);
            // 发出事件
            // this.$emit("on-change", { html, text, newQuill })
        })
        // // 将一些 quill 自带的事件传递出去
        // newQuill.on("text-change", (delta:any, oldDelta:any, source:any) => {
        //     this.$emit("on-text-change", delta, oldDelta, source)
        // })
        // newQuill.on("selection-change", (range:any, oldDelta:any, source:any) => {
        //     this.$emit("on-selection-change", range, oldDelta, source)
        // })
        // newQuill.on("editor-change", (eventName:any, ...args:any[]) => {
        //     this.$emit("on-editor-change", eventName, ...args)
        // })
    }
};
